const state = {
  ImgFolderPath: null, //图片虚拟文件夹路径
  NewsHost: null, //新闻host
  WebSocketUrl: null,
  ResourceFolderPath: null,
  SoftwareFolderPath: null,
  EmulatorSoftwareFolderPath: null,
  EmulatorResourceFolderPath: null,
  IsEnableUploadEmulatorSoftWare2LocalServer: false
};

const getters = {
  ImgFolderPath(state) {
    return state.ImgFolderPath || sessionStorage.getItem("ImgFolderPath");
  },
  ResourceFolderPath(state) {
    return (
      state.ResourceFolderPath || sessionStorage.getItem("ResourceFolderPath")
    );
  },
  SoftwareFolderPath(state) {
    return (
      state.SoftwareFolderPath || sessionStorage.getItem("SoftwareFolderPath")
    );
  },
  EmulatorSoftwareFolderPath(state) {
    return (
      state.EmulatorSoftwareFolderPath ||
      sessionStorage.getItem("EmulatorSoftwareFolderPath")
    );
  },
  EmulatorResourceFolderPath(state) {
    return (
      state.EmulatorResourceFolderPath ||
      sessionStorage.getItem("EmulatorResourceFolderPath")
    );
  },
  NewsHost(state) {
    return state.NewsHost || sessionStorage.getItem("NewsHost");
  },
  WebSocketUrl(state) {
    return state.WebSocketUrl || sessionStorage.getItem("WebSocketUrl");
  },
  IsEnableUploadEmulatorSoftWare2LocalServer(state) {
    return (
      state.IsEnableUploadEmulatorSoftWare2LocalServer ||
      sessionStorage.getItem("IsEnableUploadEmulatorSoftWare2LocalServer")
    );
  }
};

const mutations = {
  SAVE_ImgFolderPath(state, value) {
    state.ImgFolderPath = value;
    sessionStorage.setItem("ImgFolderPath", value);
  },
  SAVE_ResourceFolderPath(state, value) {
    state.ResourceFolderPath = value;
    sessionStorage.setItem("ResourceFolderPath", value);
  },
  SAVE_SoftwareFolderPath(state, value) {
    state.SoftwareFolderPath = value;
    sessionStorage.setItem("SoftwareFolderPath", value);
  },
  SAVE_EmulatorSoftwareFolderPath(state, value) {
    state.EmulatorSoftwareFolderPath = value;
    sessionStorage.setItem("EmulatorSoftwareFolderPath", value);
  },
  SAVE_EmulatorResourceFolderPath(state, value) {
    state.EmulatorResourceFolderPath = value;
    sessionStorage.setItem("EmulatorResourceFolderPath", value);
  },
  SAVE_NewsHost(state, value) {
    state.NewsHost = value;
    sessionStorage.setItem("NewsHost", value);
  },
  SAVE_WebSocketUrl(state, value) {
    state.WebSocketUrl = value;
    sessionStorage.setItem("WebSocketUrl", value);
  },
  SAVE_IsEnableUploadEmulatorSoftWare2LocalServer(state, value) {
    state.IsEnableUploadEmulatorSoftWare2LocalServer = value;
    sessionStorage.setItem("IsEnableUploadEmulatorSoftWare2LocalServer", value);
  }
};

const actions = {
  saveImgFolderPath(context, value) {
    context.commit("SAVE_ImgFolderPath", value);
  },
  saveResourceFolderPath(context, value) {
    context.commit("SAVE_ResourceFolderPath", value);
  },
  saveSoftwareFolderPath(context, value) {
    context.commit("SAVE_SoftwareFolderPath", value);
  },
  saveEmulatorSoftwareFolderPath(context, value) {
    context.commit("SAVE_EmulatorSoftwareFolderPath", value);
  },
  saveEmulatorResourceFolderPath(context, value) {
    context.commit("SAVE_EmulatorResourceFolderPath", value);
  },
  saveNewsHost(context, value) {
    context.commit("SAVE_NewsHost", value);
  },
  saveWebSocketUrl(context, value) {
    context.commit("SAVE_WebSocketUrl", value);
  },
  saveIsEnableUploadEmulatorSoftWare2LocalServer(context, value) {
    context.commit("SAVE_IsEnableUploadEmulatorSoftWare2LocalServer", value);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/js/store/modules/globalConfig.js